import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { manualOrderAdminProductWiseJSON } from "../../DynamicFormsJson/Transaction/manualOrderAdminProductWise";
import { getCategoryForStakeholderByStockHolderId } from "../../Slice/category.slice";
import { getItemwiseBatchByProductAndStockHolderIdNew } from "../../Slice/manageStock.slice";
import {
  getProductByCategoryIdAndStockHolderIdForStakeHolder,
  getProductBySubCategory,
} from "../../Slice/product.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import RTTable from "../../components/Comman/RT/RTTable";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { DarkBlue } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import { getStockStackHolders } from "../../Slice/StackHolder.slice";
import {
  deleteWarningMsg,
  noInternetMsg,
  saveFailedMsg,
  saveWarningMsg,
  savemsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import CreditNoteHeaderForm from "../Request Batchwise GRN/RequestBatchwiseGRNHeaderForm";
import { getSubCategoryByCategory } from "../../Slice/subCategory.slice";
import dayjs from "dayjs";
import SubmitPopUp from "./SubmitPopUp";

class ManualOrderAdminProductWise extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowList: [],
      formErrors: {},
      productStock: [],
      stockHolderId: "",
      openPopUp: false,
      fieldData: { calStock: "1" },
      dynamicMasterData: {
        categoryDetail: this.props.categoryList.categoryForStakeholder,
        subCategoryDetail: this.props.subCategoryList?.subCategory,
        productDetail: this.props.productList.activeAllProduct,
        batchDetail: this.props.batchList.itemwiseBatchData,
      },
    };
  }

  async componentDidMount() {
    this.setState({
      rowList: [],
    });
    const { showLoador, getStockStackHolders, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getStockStackHolders().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      apiGet({
        url: endpoint.manageStockHeaderLatest + "/get-stock-by-current-date",
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          this.setState({
            productStock: data.data.productStocks,
          });
        }
      });

    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.stakeholdersList !== nextProps.stakeholdersList) {
      if (
        this.props.stakeholdersList?.stockStakeHolders !==
        nextProps.stakeholdersList?.stockStakeHolders
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stakeholdersDetail: nextProps.stakeholdersList?.stockStakeHolders,
          },
        });
      }
    }
    if (this.props.categoryList !== nextProps.categoryList) {
      if (
        this.props.categoryList.categoryForStakeholder !==
        nextProps.categoryList.categoryForStakeholder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            categoryDetail: nextProps.categoryList.categoryForStakeholder,
          },
        });
      }
    }
    if (this.props.subCategoryList !== nextProps.subCategoryList) {
      if (
        this.props.subCategoryList?.subCategory !==
        nextProps.subCategoryList?.subCategory
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            subCategoryDetail: nextProps.subCategoryList?.subCategory,
          },
        });
      }
    }
    if (this.props.productList !== nextProps.productList) {
      if (
        this.props.productList?.activeAllProduct !==
        nextProps.productList?.activeAllProduct
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            productDetail: nextProps.productList?.activeAllProduct,
          },
        });
      }
    }
    if (this.props.batchList !== nextProps.batchList) {
      if (
        this.props.batchList.itemwiseBatchData !==
        nextProps.batchList.itemwiseBatchData
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            batchDetail: nextProps.batchList.itemwiseBatchData,
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const {
      getProductByCategoryIdAndStockHolderIdForStakeHolder,
      getItemwiseBatchByProductAndStockHolderIdNew,
      getCategoryForStakeholderByStockHolderId,
      showLoador,
      showNotification,
      getSubCategoryByCategory,
      getProductBySubCategory,
    } = this.props;
    const { stockHolderId } = this.state;

    if (navigator.onLine) {
      if (data.stakeholder) {
        this.setState({
          stockHolderId: data.stakeholder,
          rowList: [],
        });
        showLoador({ loador: true });
        await getCategoryForStakeholderByStockHolderId({
          stockStakeHolderId: data.stakeholder,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.category) {
        showLoador({ loador: true });
        await getSubCategoryByCategory({
          categoryId: data.category,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.subCategory) {
        showLoador({ loador: true });
        await getProductBySubCategory({
          subCategoryId: data.subCategory,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }

      if (data.product && this.state.fieldData.date) {
        showLoador({ loador: true });
        await getItemwiseBatchByProductAndStockHolderIdNew({
          orderDate: this.state.fieldData.date.format("DD-MM-YYYY"),
          productId: data.product,
          stockStakeHolderId: stockHolderId,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  };

  onSearch = (data) => {
    const { rowList, dynamicMasterData } = this.state;
    let catList = dynamicMasterData["categoryDetail"]
      ? dynamicMasterData["categoryDetail"].filter(
        (row) => row.id == data.category
      )
      : [];

    let subCatList = dynamicMasterData["subCategoryDetail"]
      ? dynamicMasterData["subCategoryDetail"].filter(
        (row) => row.id == data.subCategory
      )
      : [];
    let productList = dynamicMasterData["productDetail"]
      ? dynamicMasterData["productDetail"].filter(
        (row) => row.id == data.product
      )
      : [];



    this.setState({
      rowList: [
        ...rowList,
        {
          index: rowList.length + 1,
          categoryName: catList.length != 0 ? catList[0].name : "-",
          subCategoryName: subCatList.length != 0 ? subCatList[0].name : "-",
          productName: productList.length != 0 ? productList[0].name : "-",
          productObj: productList.length != 0 ? productList[0] : "-",
          hsnCode:
            productList.length != 0
              ? productList[0].taxPercentage.hsnCode
              : "-",
          mrp: productList.length != 0 ? productList[0].mrp : "-",
          uom:
            productList.length != 0 ? productList[0].stakeHolderUomName : "-",
          stakeHolderUom:
            productList.length != 0 ? productList[0].stakeHolderUom : "-",
          tax: productList.length != 0 ? productList[0].taxPercentage.id : "-",
          uomConversionValue:
            productList.length != 0 ? productList[0].uomConversionValue : "-",
          ...data,
          total: (+data.rate * +data.qty).toFixed(2),
        },
      ],
    });
  };


  onSubmitOpenPopUp = () => {
    this.setState({
      openPopUp: true,
    })
  }

  onSubmitData = () => {
    if (this.checkValidationOnSubmit()) {
      const { rowList, fieldData } = this.state;
      const stakeholderOutletDetails = rowList.map((orderData) => {
        return {
          product: orderData.productObj,
          qty: orderData.qty,
        };
      });
      const dataToSave = {
        fromOrder: fieldData.stakeholder,
        orderDate: dayjs().format("DD-MM-YYYY"),
        discountOnBillPer: 0,
        stockStakeHolderOrderDetails: stakeholderOutletDetails,
        remark: "",
      };
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.onSave(dataToSave);
        }
      });
    }
  };

  onSave = (dataToSave) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: endpoint.stockStakeholderOrderHeader + "/manual",
        postBody: dataToSave,
      }).then(({ data, success }) => {
        if (success) {
          showLoador({ loador: false });
          window.location.replace("/manual-order-admin-product-wise");
          showNotification({ msg: savemsg });
        } else {
          showLoador({ loador: false });
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  mandatoryCheck = () => {
    let formValid = true;
    const { fieldData } = this.state;

    let formErrors = {};
    manualOrderAdminProductWiseJSON.fieldMeta.forEach((currentField) => {
      if (currentField.isMandatory) {
        if (
          (currentField.controlType === "datepicker" &&
            (fieldData[currentField.dataKey] === undefined ||
              fieldData[currentField.dataKey] === "")) ||
          (currentField.controlType !== "datepicker" &&
            currentField.controlType !== "autocomplete" &&
            (fieldData[currentField.dataKey] === undefined ||
              fieldData[currentField.dataKey] === null ||
              fieldData[currentField.dataKey].toString().trim() === ""))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        } else if (
          currentField.controlType === "autocomplete" &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            (!currentField.isRootLevelKey &&
              fieldData[currentField.dataKey] != undefined &&
              fieldData[currentField.dataKey] != null &&
              fieldData[currentField.dataKey].id == null))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideTextfield") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.error} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideDatepicker") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            fieldData[currentField.dataKey].toString().trim() === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideAutocomplete") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            fieldData[currentField.dataKey].toString().trim() === "")
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      } else if (currentField.controlType === "hideMultiSelect") {
        if (
          fieldData[currentField.tableDataKey] === currentField.open &&
          (fieldData[currentField.dataKey] === undefined ||
            fieldData[currentField.dataKey] === null ||
            (fieldData[currentField.dataKey] &&
              fieldData[currentField.dataKey].length == 0))
        ) {
          formValid = false;

          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `*${currentField.label} is required`,
            },
          };
        }
      }
    });
    this.setState({
      formErrors: formErrors,
    });
    return formValid;
  };

  ValidationCheck = () => {
    let formValid = true;
    const { fieldData } = this.state;

    let formErrors = {};
    manualOrderAdminProductWiseJSON.fieldMeta.forEach((currentField) => {
      if (currentField.valid) {
        if (
          currentField.validName === "email" &&
          !validEmail.test(fieldData[currentField.dataKey])
        ) {
          formValid = false;
          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `${currentField.label} is Invalid`,
            },
          };
        }
        if (
          currentField.validName === "zero" &&
          fieldData[currentField.dataKey] === 0
        ) {
          formValid = false;
          formErrors = {
            ...formErrors,
            [currentField.dataKey]: {
              isError: true,
              errorText: `${currentField.label} is Invalid`,
            },
          };
        }
      }
    });
    this.setState({
      formErrors: formErrors,
    });
    return formValid;
  };

  checkValidationOnSubmit = () => {
    if (this.mandatoryCheck()) {
      return this.ValidationCheck();
    } else {
      return false;
    }
  };

  onDataChange = (fieldName, newValue) => {
    const { fieldData } = this.state;
    const dataToSearch = {};
    const dataToReset = { ...this.state.fieldData };
    let listError = false;
    manualOrderAdminProductWiseJSON.fieldMeta.map((currentField) => {
      if (currentField.getDate && currentField.dataKey === fieldName) {
        dataToReset[currentField.getDate] = newValue.add(365, "day");
      }
      if (currentField.dataKey === fieldName && currentField.getListId) {
        const masterKeyList = currentField.getListId.split(",");
        masterKeyList.map((key) => {
          if (fieldName === key) {
            dataToSearch[key] = newValue;
          } else if (fieldData[key]) {
            dataToSearch[key] = fieldData[key];
          }
          return null;
        });

        this.getListById(dataToSearch);
      }
      if (currentField.getListFrom) {
        const masterKeyList = currentField.getListFrom.split(",");
        masterKeyList.map((key) => {
          if (key == fieldName && dataToReset[key]) {
            delete dataToReset[currentField.dataKey];
          }
        });
      }
      if (
        !listError &&
        fieldData[currentField.dataKey] &&
        currentField.controlType != "datepicker" &&
        currentField.getListFrom == undefined
      ) {
        dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
      }
      return null;
    });

    dataToReset[fieldName] = newValue;
    this.setState({
      fieldData: dataToReset,
    });
  };

  getDataForDisabled = (value) => {
    const { dynamicMasterData, rowList, productStock } = this.state;
    let productStockList = productStock.filter(
      (row) => row.product.id == value
    );
    console.log(productStock.filter((row) => row.primaryClosingQty > 0));

    if (productStockList.length != 0) {
      return {
        secondaryClosingQty:
          productStockList.length != 0 && productStockList[0].primaryClosingQty,
        uom: productStockList.length != 0 && productStockList[0].product.stakeHolderUom.name,
        rate: productStockList.length != 0 && productStockList[0].product.rate,
      };
    }

    // let productList = dynamicMasterData["productDetail"]
    //   ? dynamicMasterData["productDetail"].filter((row) => row.id == value)
    //   : [];


    // let batchList = dynamicMasterData["batchDetail"]
    //   ? dynamicMasterData["batchDetail"].filter((row) => row.id == value)
    //   : [];
    // if (batchList.length != 0) {
    //   let newBatchList = rowList.filter((row) => row.batch == batchList[0].id);
    //   if (newBatchList.length != 0) {
    //     let newBatchQty = 0;
    //     newBatchList.map((row) => {
    //       newBatchQty = newBatchQty + +row.qty;
    //     });
    //     return {
    //       secondaryClosingQty: (+batchList[0].qty - newBatchQty).toString(),
    //       batchQty: batchList.length != 0 && batchList[0].qty,
    //     };
    //   }
    //   return {
    //     secondaryClosingQty: batchList.length != 0 && batchList[0].qty,
    //     batchQty: batchList.length != 0 && batchList[0].qty,
    //   };
    // }
    // if (productList.length != 0) {
    //   return {
    //     rate: productList.length != 0 && productList[0].rate,
    //     uom: productList.length != 0 && productList[0].stakeHolderUomName,
    //     uomConversionValue:
    //       productList.length != 0 && productList[0].uomConversionValue,
    //   };
    // }
  };

  getDataForCalculate = (value, fieldData) => {
    const { dynamicMasterData, rowList } = this.state;
    // let batchList = dynamicMasterData["batchDetail"]
    //   ? dynamicMasterData["batchDetail"].filter(
    //     (row) => row.id == fieldData.batch
    //   )
    //   : [];
    // if (rowList.length != 0) {
    //   let newQty = fieldData.batchQty;
    //   rowList.map((row) => {
    //     if (row.batch == fieldData.batch) {
    //       if (batchList.length != 0 && fieldData.batch) {
    //         let newBatchList = batchList.filter(
    //           (rowData) => rowData.id == row.batch
    //         );
    //         if (newBatchList.length != 0) {
    //           newQty = newQty - +row.qty;
    //         }
    //       }
    //     }
    //   });
    //   return {
    //     secondaryClosingQty: (+newQty - +value).toString(),
    //     secondaryQty: newQty,
    //   };
    // } else if (fieldData.batch) {
    //   if (batchList.length != 0) {
    //     return {
    //       secondaryClosingQty: (+batchList[0].qty - value).toString(),
    //       secondaryQty: +batchList[0].qty,
    //     };
    //   }
    // }
  };

  rowDelete = (rowData) => {
    swal({
      title: "Are you sure?",
      text: deleteWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const rowListData = this.state.rowList.filter(
          (row) => row.index != rowData.index
        );
        const row = rowListData.map((rowListDataObj, index) => {
          return { ...rowListDataObj, index: index + 1 };
        });
        this.setState({
          rowList: row,
        });
      }
    });
  };
  toggle = () => {
    this.setState({
      openPopUp: false,
    })
  }

  render() {
    const { dynamicMasterData, rowList, formErrors, fieldData, openPopUp } = this.state;
    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <CreditNoteHeaderForm
            getListById={this.getListById}
            dynamicMasterData={dynamicMasterData}
            screenTitle={manualOrderAdminProductWiseJSON.screenTitle}
            fieldMeta={manualOrderAdminProductWiseJSON.fieldMeta}
            apiBaseURL={manualOrderAdminProductWiseJSON.apiBaseURL}
            formErrors={formErrors}
            showSaveBtn={manualOrderAdminProductWiseJSON.showSaveBtn}
            showSaveBtnMain={false}
            fieldData={fieldData}
            onDataChange={this.onDataChange}
          />
          <LabelCompo
            className="text-black"
            style={{ fontSize: "20px", color: DarkBlue }}
            label={"Add Product"}
          />
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            sx={{ paddingTop: 2 }}
          >
            <DynamicFormWithoutSave
              showSaveBtn={true}
              showSaveBtnMain={false}
              dynamicMasterData={dynamicMasterData}
              getListById={this.getListById}
              searchList={manualOrderAdminProductWiseJSON.searchList}
              showTitle={manualOrderAdminProductWiseJSON.showTitle}
              screenTitle={manualOrderAdminProductWiseJSON.screenTitle}
              fieldMeta={manualOrderAdminProductWiseJSON.fieldMetaDetails}
              showCancel={manualOrderAdminProductWiseJSON.showCancel}
              showBackToList={manualOrderAdminProductWiseJSON.showBackToList}
              apiBaseURL={manualOrderAdminProductWiseJSON.apiBaseURL}
              showSaveNextBtn={manualOrderAdminProductWiseJSON.showSaveNextBtn}
              saveBtnText={"ADD"}
              onSave={this.onSearch}
              resetAfterSave={true}
              getDataForDisabled={this.getDataForDisabled}
              getDataForCalculate={this.getDataForCalculate}
            />
          </Grid>

          <br />
          <RTTable
            showPegination={false}
            columns={[
              { name: "index", title: "Sr. No.", align: "center" },
              { name: "categoryName", title: "Category" },
              { name: "subCategoryName", title: "Sub-Category" },
              { name: "productName", title: "Product" },
              { name: "uom", title: "UOM", align: "center" },
              { name: "qty", title: "Quantity", align: "right" },
              { name: "action", title: "Action" },
            ]}
            tableData={rowList}
            showEditIcon={false}
            isActionColActive={true}
            showDeleteIcon={true}
            rowDelete={this.rowDelete}
          />
          <br />
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            justifyContent="right"
          >
            <ButtonCompo
              size="medium"
              type="Submit"
              variant="contained"
              name="Submit"
              onClick={this.onSubmitOpenPopUp}
            />
          </Grid>
          {openPopUp && (
            <>
              <SubmitPopUp
                open={openPopUp}
                tableData={rowList}
                onCancel={this.toggle}
                columns={[
                  {
                    title: "Sr. No.",
                    name: "index",
                    positionCenter: true,
                    showInscreen: true,
                    alignCenter: "center",
                  },
                  {
                    title: "Category",
                    name: "categoryName",
                    positionCenter: false,
                    showInscreen: true,
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "Sub-Category",
                    name: "subCategoryName",
                    positionCenter: true,
                    showInscreen: true,
                    alignCenter: "left",
                    canSearch: true,
                  },

                  {
                    title: "Product",
                    name: "productName",
                    positionCenter: false,
                    showInscreen: true,
                    alignCenter: "left",
                    canSearch: true,
                  },
                  {
                    title: "UOM",
                    name: "uom",
                    positionCenter: false,
                    showInscreen: true,
                    alignCenter: "center",
                    canSearch: true,
                  },
                  {
                    title: "Quantity",
                    name: "qty",
                    positionCenter: false,
                    showInscreen: true,
                    alignCenter: "right",
                    canSearch: true,
                  },
                ]}
                onSubmit={this.onSubmitData}
              />
            </>
          )}
        </Paper>
      </>


    );
  }
}
const mapStateToProps = (state) => ({
  categoryList: state.category,
  subCategoryList: state.subCategory,
  productList: state.product,
  batchList: state.manageStockByDate,
  stakeholdersList: state.stackholder,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getSubCategoryByCategory,
  getProductBySubCategory,
  getItemwiseBatchByProductAndStockHolderIdNew,
  getProductByCategoryIdAndStockHolderIdForStakeHolder,
  getStockStackHolders,
  getCategoryForStakeholderByStockHolderId,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ManualOrderAdminProductWise);
